<template>
    <div class="comment">
        <div ref="top_topic" class="top_topic clear">
            <div class="tabBox">
                <div v-show="item.id!=0" class="item" v-for="item in tagList" :key="item.id" @click="jumpDetails(item.id)">#{{item.title}}</div>
            </div>
            <div class="more" @click="showToggle"></div>
        </div>
        <waterfall 
            :col='col' 
            :data="newShowList"
            :width="itemWidth" 
            :gutterWidth="gutterWidth"
            @loadmore="loadmore"  
        >
            <template>
                <div v-for="item in newShowList" :key="item.id">
                    <WaterfallList :isPattingAll="true" :type="2" :data="item" />
                </div>
            </template>
        </waterfall>
        <div class="no-more" v-show="!empty">加载中...</div>
        <div class="no-more" v-show="empty">没有更多了</div>
    </div>
</template>

<script>
import { WaterfallList } from '@/components'
import { getNewShowImage, getPattingAll } from '@/request/api';
import { navigate } from '@/pages/index/custom'

export default {
    components: {
        WaterfallList,
    },
    data() {
        return {
            newShowList: [], // 最新晒照列表
            col: 2, // 瀑布流列数
            page: 1,  // 瀑布流分页
            empty: false,
            toggleFlag: false,
            tagList: [],  // 顶部话题列表
        }
    },
    methods: {
        loadmore(index){
            this.initgetPattingAll()
        },
        initgetPattingAll() {
            let id = null;
            if(this.newShowList.length > 0) {
                id = this.newShowList[this.newShowList.length - 1].id;
            }
            getPattingAll({
                max_id: id ? id : 0,
                pcount: 8,
                page: this.page
            }).then( res => {
                let {data, error_code} = res;
                if(error_code === 0) {
                    let {data, rec, error_code} = res;
                    if(error_code === 0) {
                        if(data.tag.length > 0 && data.tag) {
                            this.tagList = data.tag;
                        }
                        if(data.video.length > 0 && data.video) {
                            if(rec && rec.length > 0) {
                                rec.forEach(item => {
                                    item.isTopic = true;
                                    data.video.splice(rec.index, 0, item)
                                });
                            }
                            data.video.map(item => this.newShowList.push(item));
                            this.page++
                        } else {
                            this.empty = true
                        }
                    }
                }
            }).catch( error => {
                console.log(error)
            })
        },
        // 显示更多
        showToggle() {
            navigate("/patTopList")
        },
        // 话题详情页跳转
        jumpDetails(id) {
            navigate({ path: "/patTopDetails", query: { id: id } });
        }
    },
    computed:{
        itemWidth(){  
            return Math.floor((document.documentElement.clientWidth-55)/2)
        },
        gutterWidth(){
            return 15
        }
    },
    created() {
        this.initgetPattingAll();
    },
    beforeCreate: function () {
        document.getElementsByTagName('html')[0].style.height = 'auto'
        document.getElementsByTagName('body')[0].style.height = 'auto'
    },
}
</script>

<style lang="less" scoped>
.top_topic {
    position: relative;
    padding-right: 34px;
    width: 100%;
    height: auto;
    line-height: 2.125rem;
    margin-bottom: .75rem;
    .tabBox {
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        text-align: justify;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
    }
    .item {
        display: inline-block;
        height: 100%;
        background-color: #FF4c67;
        font-size:12px;
        font-weight:400;
        color:rgba(255,255,255,1);
        box-sizing: border-box;
        padding-left: 11px;
        padding-right: 8px;
        border-radius: 100px;
        margin-right: .5rem;
        margin-bottom: 8px;
    }
    .more {
        position: absolute;
        right: 0;
        top: 0;
        width: 34px;
        height: 34px;
        background: url(../../../../assets/img/icon_more_w.png) no-repeat center center;
        background-size: 34px 34px;
        background-color: #f8f8f8;
        box-shadow: -10px 0px 20px 2px #fff;
    }
}
.comment {
    background-color: #f8f8f8;
    padding: 4.5rem 20px 0 20px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    .no-more {
        text-align: center;
        height: 1.875rem;
        color: #ccc;
        font-size: 14px;
        padding-bottom: 70px;
    }
    .vue-waterfall {
        padding-bottom: 0px;
    }
}
</style>